import React, { Suspense } from 'react';
import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

import { CompareModes } from 'context/entityContext';
import SkeletonLoader from 'components/data-containers/PositionsTable/PositionTracker/SkeletonLoader';

const ChartPositionTracker = React.lazy(() =>
  import(
    'components/data-containers/PositionsTable/PositionTracker/ChartPositionTracker'
  )
);

interface IPositionTrackerProps {
  compareMode?: CompareModes;
}

const PositionTracker: React.FC<IPositionTrackerProps> = (props) => {
  const { compareMode } = props;
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>
          Unfortunately there are no other components available in compare mode
          on this topic for tracks.
        </Message>
      </Layout.MaxWidth>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <Suspense fallback={<SkeletonLoader title="Position Tracker" short />}>
        <ChartPositionTracker productType="track" />
      </Suspense>
    </div>
  );
};

export default PositionTracker;
